import { useTranslation } from 'react-i18next';
import { mockSampleRequests } from '@/mocks/dashboard';
import DashboardSamples from './components/DashboardSamples';

export default function SamplesPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.samples.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Sample requests and status</p>
      </div>
      <DashboardSamples samples={mockSampleRequests} />
    </div>
  );
}